export default function Notification({ dataNotificacion, callback, notificationId }) {

    return (
        <div className='d-flex flex-stack py-4'>
            <div className='d-flex align-items-center'>
                <div className="symbol symbol-40px symbol-circle me-4">
                    <div className="symbol-label fs-2 fw-bold">{dataNotificacion.value2[0]}</div>
                    <span className="position-absolute translate-middle bottom-0 top-75 start-100 bg-blue rounded-circle border border-2 border-white h-15px w-15px"></span>
                </div>

                <div className='mb-0'>
                    <a className='text-gray-900 fs-6'
                        onClick={() => callback(dataNotificacion)}
                    >
                        {dataNotificacion.value2}
                    </a>
                    {
                        (
                            (dataNotificacion.value1 && notificationId != '3') &&
                            <div className='text-gray-400 fs-7'>
                                Código: {dataNotificacion.value1}
                            </div>
                        )
                    }

                </div>
            </div>
        </div>
    )
}
